import styled from 'styled-components';
export const ErrorContainer = styled.div `
  padding: ${({ theme }) => theme.spacing.lg}px;
  margin: ${({ theme }) => theme.spacing.md}px;
  background: ${({ theme }) => theme.colors.red_5};
  border: 1px solid ${({ theme }) => theme.colors.red_4};
  border-radius: ${({ theme }) => theme.border_radius.md};
  text-align: center;
`;
export const ErrorTitle = styled.h3 `
  color: ${({ theme }) => theme.colors.error};
  margin: 0 0 ${({ theme }) => theme.spacing.sm}px 0;
  font-size: ${({ theme }) => theme.fonts.body1};
`;
export const ErrorMessage = styled.p `
  color: ${({ theme }) => theme.colors.red_1};
  margin: 0 0 ${({ theme }) => theme.spacing.md}px 0;
`;
export const RetryButton = styled.button `
  background: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.white_1};
  border: none;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.red_1};
  }
`;
